import { render, staticRenderFns } from "./BlockingCTABox.vue?vue&type=template&id=2fcdda10"
import script from "./BlockingCTABox.vue?vue&type=script&lang=js"
export * from "./BlockingCTABox.vue?vue&type=script&lang=js"
import style0 from "./BlockingCTABox.vue?vue&type=style&index=0&id=2fcdda10&prod&lang=scss"


/* normalize component */
import normalizer from "!../../web-components/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports